import dynamic from 'next/dynamic';

const ContentList = dynamic(
  () => import('@components/ContentList/ContentList')
);
const Pagination = dynamic(() => import('@components/Pagination/Pagination'));
const SectionTitle = dynamic(
  () => import('@components/SectionTitle/SectionTitle')
);
const Title = dynamic(() => import('@components/Title/Title'));

export type ListingProps = {
  posts: [
    {
      title: string;
      slug: string;
      hero: string;
      updated_at: string;
    }
  ];
  pages: [
    {
      active: boolean;
      number: number;
      path: string;
    }
  ];
  title: string;
};

interface ListingPageProps extends ListingProps {
  section: Section;
}

const ListingPage = ({ posts, pages, section, title }: ListingPageProps) => (
  <>
    <Title>{title}</Title>
    <ContentList posts={posts} />

    <Pagination pages={pages} section={section.toLowerCase()} />
  </>
);

export default ListingPage;
